import { // @todo move to nwjs-marketplace and backport.
getPayPerCall } from '@nerdwallet/cc-utils/lib/offer-api/selectors';
import { getLegacyId } from '@nerdwallet/marketplace/selectors/common';
import { getName } from '@nerdwallet/marketplace/selectors/credit-cards';
export default (function (_ref) {
  var marketplaceEntity = _ref.marketplaceEntity,
      shortButton = _ref.shortButton;
  return {
    isCC: true,
    pay_per_call: getPayPerCall(marketplaceEntity),
    // Override with legacy ID for tracking continuity :(
    // @todo This is a product req that we should updated ASAP.
    productId: getLegacyId(marketplaceEntity),
    productName: getName(marketplaceEntity),
    showIcon: !shortButton,
    text: 'Apply Now'
  };
});